const globals = {
    "app-application-name": "Application.name",
    "app-id-applicazione": "",
    // "app-nome-dominio": process.env.REACT_APP_APP_NOME_DOMINIO,
    "app-url-backend": process.env.REACT_APP_APP_URL_BACKEND,
    "app-url-bucket": process.env.REACT_APP_BUCKET_URL,
    "app-url-auth": process.env.REACT_APP_AUTH_URL,
    "app-url-backend-ms-cms-rss": process.env.REACT_APP_APP_URL_BACKEND_MS_CMS_RSS,
    "app-url-backend-ms-ricerca-rss": process.env.REACT_APP_APP_URL_BACKEND_MS_RICERCA_RSS,
    "site-id": process.env.REACT_APP_SITE_ID,
    "lingua-default": "it-IT",
    "lingua_default": "it",
};

export default globals;